import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {LoadingService} from '../loading/loading.service';
import {Observable, catchError, throwError} from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {DataService} from '../data.service';
import {CarrierRateProcurement} from '../../features/carrier-rate-procurement/carrier-rate-procurement';
import {IffRates} from '../../features/iff-rates/iff-rates';

@Injectable()
export class CarrierRateProcurementService extends DataService {
  headers = new HttpHeaders({'Content-Type': 'application/json'});

  private tmssloader;
  private selectURI = this.apiUri + '/carrierRateProcSelect';
  private reportURI = this.apiUri + '/carrierRateProcReport';
  private iffRatesURI = this.apiUri + '/iffRatesAdminList';
  private iffRatesURIMap = this.apiUri + '/iffRatesAdminListmap';
  
  private carrierRateProcXlsxURI = this.apiUri + '/carrierRateProcExport';

  constructor(protected http: HttpClient, private router: Router, private loader: LoadingService) {
    super(http);
    this.tmssloader = this.loader;
  }

  // call to server for loading  All IFF Rates
  getIFFRatesList(type: String): Observable<any> {
    const iffRatesUrl = this.iffRatesURI + '/' + type;
    return this.http.get<any>(iffRatesUrl).pipe(catchError(this.handleError));

  }
  // call to create a new IFF Rate record
  createIffRate(formSelect: IffRates): Observable<any> {
    return this.http.post<any>(this.iffRatesURIMap, formSelect, {headers: this.headers});
  }

// call to delete a IFF Rate record
  deleteIffRate(formSelect: IffRates): Observable<any> {
    return this.http.post<any>(this.iffRatesURI + '/' + 'delete', formSelect, {headers: this.headers}).pipe(catchError(this.handleError));
  }


  // call to server for select box options
  getSelectOptions(type: String): Observable<any> {
    const carrierRateProcUrl = this.selectURI + '/' + type;
    return this.http.get<any>(carrierRateProcUrl)
      .pipe(catchError(this.handleError));

  }

  getReport(formSelect: CarrierRateProcurement): Observable<any> {
    return this.http.post<any>(this.reportURI, formSelect, {headers: this.headers})
    .pipe(catchError(this.handleError));
  }


  // handling error
  errorHandler(error: any): any {
    if (error.status < 400) {
      return throwError(new Error(error.status));
    }
  }

  // call to server for carrier rate proc report
  getCarrierRateProcXlsx(formSelect: CarrierRateProcurement): Observable<any> {
    return this.http.post<any>(this.carrierRateProcXlsxURI, formSelect, {headers: this.headers})
      .pipe(catchError(this.handleError));

  }
}
